module.exports = __webpack_public_path__ + "img/static-white.943733e9.png";